import Vue from '_lib/_vue';
import App from './index.vue';

Vue.config.productionTip = false;

import WebpDirective from '_lib/plugin/webp-directive.js';
Vue.use(WebpDirective);

import HeyboxIcon from '_lib/plugin/heybox-icon.js';
Vue.use(HeyboxIcon);

import reportPlugin from '_lib/plugin/heybox-report.js';
Vue.use(reportPlugin);

import { HbShareHeader } from '@heybox-components/hb-share-header';
Vue.use(HbShareHeader);

import {
  HbLoading,
  HbDialog,
  HbModal,
  HbTabs,
  HbTabPane,
  HbButton,
  HbSwitch
} from '@heybox-components/heybox-ui';
Vue.use(HbLoading);
Vue.use(HbDialog);
Vue.use(HbModal);
Vue.use(HbTabs);
Vue.use(HbTabPane);
Vue.use(HbButton);
Vue.use(HbSwitch)

new Vue({
  render: (h) => h(App),
}).$mount('#app');
